import React, { useState } from 'react';
import { OverridesInput, OverridesTextarea, OverridesCheckBox } from '../FormInputs';
import { defaultDarValue } from '../utils/data';

export default function Document8130Form({ documentDefaults }) {
    const [showLeft, setShowLeft] = useState(documentDefaults?.form8130?.showLeft);
    const [showRight, setShowRight] = useState(documentDefaults?.form8130?.showRight);
    const [darDisplayName, setDarDisplayName] = useState(getPriorityDarValue());

    function getPriorityDarValue() {
        if (documentDefaults?.form8130?.darDisplayName) return documentDefaults?.form8130?.darDisplayName;
        const darValues = documentDefaults?.form8130?.DAR ?? null;

        const priorityDAR = darValues?.length ? darValues?.find((dar) => dar.priority === true) : null;
        return priorityDAR?.displayName ?? defaultDarValue.displayName;
    }

    const handleToggleLeftOrRight = (toggleSide) => {
        if (toggleSide === 'left') {
            setShowLeft(true);
            setShowRight(false);
        } else if (toggleSide === 'right') {
            setShowLeft(false);
            setShowRight(true);
        }
    };

    const handleDarWorkerUpdateOnDateChange = (event) => {
        const selectedDate = event.target.value;
        const matchingDarWorker = documentDefaults?.form8130?.DAR.find((dar) => dar.startDate === selectedDate);

        if (matchingDarWorker) {
            documentDefaults.form8130.authorizationName = matchingDarWorker.authorizationName;
            documentDefaults.form8130.authorizationNumber = matchingDarWorker.authorizationNumber;
            documentDefaults.form8130.darDisplayName = matchingDarWorker.displayName;
            setDarDisplayName(matchingDarWorker.displayName);
        }
        if (!matchingDarWorker) {
            documentDefaults.form8130.authorizationName = 'No DAR Available';
            documentDefaults.form8130.authorizationNumber = 'No DAR Available';
            documentDefaults.form8130.darDisplayName = 'No DAR Available';
            setDarDisplayName('No DAR Available');
        }
    };

    return (
        <>
            <section className='w-full flex flex-row gap-4'>
                <section className='w-1/2 flex flex-col gap-4'>
                    <OverridesInput
                        text={'4. FAA CRS#'}
                        name={'faaAddress'}
                        defaultInput={documentDefaults?.form8130?.faaAddress}
                    />
                    <OverridesInput
                        text={'7. Description'}
                        name={'partDescription'}
                        defaultInput={documentDefaults?.form8130?.partDescription}
                    />
                    <OverridesInput
                        text={'10. Serial Number:'}
                        name={'serialNumber'}
                        defaultInput={documentDefaults?.form8130?.serialNumber}
                    />
                    <OverridesCheckBox
                        text={'Show left'}
                        name={'showLeft'}
                        defaultInput={showLeft}
                        onChange={() => {
                            handleToggleLeftOrRight('left');
                        }}
                    />
                    <OverridesCheckBox
                        text={'13a. Approved design data and are in a condition for safe operation'}
                        name={'approvedDesign'}
                        disabled={!showLeft}
                        defaultInput={documentDefaults?.form8130?.approvedDesign}
                    />
                    <OverridesCheckBox
                        text={'13a. Non-approved design data specified in Block 12'}
                        name={'nonApprovedDesign'}
                        disabled={!showLeft}
                        defaultInput={documentDefaults?.form8130?.nonApprovedDesign}
                    />
                    <section className='w-full flex flex-col justify-start items-start gap-1 h-fit rounded-md bg-gray-100'>
                        <article className='flex items-center justify-start w-full rounded-md p-2 h-full gap-3'>
                            <p>DAR</p>
                        </article>
                        <article className='flex items-center justify-start w-full rounded-md p-2 h-full gap-3'>
                            <select
                                name={'darDisplayName'}
                                defaultValue={getPriorityDarValue()}
                                value={darDisplayName}
                                onChange={(e) => {
                                    // DAR logic on change is being handled in the Forms.js component.
                                    // authorizationName, authorizationNumber, and darDisplayName get set there along with the documentDefaults
                                    setDarDisplayName(e.target.value);
                                }}
                                className='w-full px-3 py-1 rounded-md border-gray-400 focus:border-black duration-100 hover:bg-gray-100 bg-white cursor-pointer border'
                            >
                                <option value={''}>{defaultDarValue.displayName}</option>
                                {documentDefaults?.form8130?.darWorkers?.map((worker, index) => {
                                    return (
                                        <option key={index} value={worker}>
                                            {worker}
                                        </option>
                                    );
                                })}
                            </select>
                        </article>
                    </section>
                    <OverridesTextarea
                        text={'12. Remarks:'}
                        name={'remarks'}
                        defaultInput={documentDefaults?.form8130?.remarks}
                    />
                </section>
                <section className='w-1/2 flex flex-col gap-4'>
                    <OverridesInput
                        text={'5. Work Order/Contract/Invoice Number'}
                        name={'customerPoNumber'}
                        defaultInput={documentDefaults?.form8130?.customerPoNumber}
                    />
                    <OverridesInput
                        text={'9. Quantity:'}
                        name={'quantity'}
                        defaultInput={documentDefaults?.form8130?.quantity}
                    />
                    <OverridesInput
                        text={'11. Status/Work:'}
                        name={'conditionCodeDescription'}
                        defaultInput={documentDefaults?.form8130?.conditionCodeDescription}
                    />
                    <OverridesCheckBox
                        text={'Show right'}
                        name={'showRight'}
                        defaultInput={showRight}
                        onChange={() => {
                            handleToggleLeftOrRight('right');
                        }}
                    />
                    <OverridesCheckBox
                        text={'14a. 14 CFR 43.9 Return to Service'}
                        name={'fourteenCfr'}
                        disabled={!showRight}
                        defaultInput={documentDefaults?.form8130?.fourteenCfr}
                    />
                    <OverridesCheckBox
                        text={'14a. Other regulation specified in Block 12'}
                        name={'otherRegulationSpecified'}
                        disabled={!showRight}
                        defaultInput={documentDefaults?.form8130?.otherRegulationSpecified}
                    />
                    <section className='w-full flex flex-col justify-start items-start gap-1 h-fit rounded-md bg-gray-100'>
                        <article className='flex items-center justify-start w-full rounded-md p-2 h-full gap-3'>
                            <p>Date</p>
                        </article>
                        <article className='flex items-center justify-start w-full rounded-md p-2 h-full gap-3'>
                            <input
                                name={'date'}
                                type='date'
                                onChange={(e) => handleDarWorkerUpdateOnDateChange(e)}
                                value={documentDefaults?.form8130?.date}
                                className={
                                    'w-full px-3 py-1 rounded-md border duration-100 hover:bg-gray-100 disabled:bg-gray-100 border-gray-400 focus:border-black'
                                }
                            />
                        </article>
                    </section>
                </section>
            </section>
        </>
    );
}
